


































































































import Vue from 'vue'
import { mapState, mapMutations, mapGetters } from 'vuex'
import SpiderTable from '@/components/spider-table.vue'
import SpiderTableFilter from '@/components/spider-table-filter.vue'
import SpiderStatusHistoryDialog from '@/components/spider-status-history-dialog.vue'
import SpiderBulkUpdateDialog from '@/components/spider-bulk-update-dialog.vue'
import SpiderBulkDeleteDialog from '@/components/spider-bulk-delete-dialog.vue'
import SpiderPublicationTransferDialog from '@/components/spider-publication-transfer-dialog.vue'
import SpiderBulkCopySettingsDialog from '@/components/spider-bulk-copy-settings-dialog.vue'
import { getSpiderStatusHistory } from '@/core/api/spiders'

const NOT_FOUND = 404
const REPEAT_DELAY = 250

export default Vue.extend({
  components: {
    SpiderTable,
    SpiderTableFilter,
    SpiderBulkUpdateDialog,
    SpiderStatusHistoryDialog,
    SpiderBulkDeleteDialog,
    SpiderPublicationTransferDialog,
    SpiderBulkCopySettingsDialog,
  },
  data: () => ({
    bulkUpdateDialog: false,
    bulkDeleteDialog: false,
    bulkCopySettingsDialog: false,
    statusHistoryDialog: false,
    publicationTransferDialog: false,
    publicationTransferContext: {
      src: null,
      dst: null,
    },
    statusHistoryItems: [],
    ctxMenuVisible: false,
    ctxMenuPositionX: 0,
    ctxMenuPositionY: 0,
    ctxMenuItem: null as any,
  }),
  computed: {
    ...mapState('spiders', {
      loading: (state: any) => state.loading,
      items: (state: any) => state.items,
      itemsCount: (state: any) => state.itemsCount,
      page: (state: any) => state.page,
      pageCount: (state: any) => state.pageCount,
      filter: (state: any) => state.filter,
    }),
    ...mapState('auth', {
      user: (state: any) => state.user,
    }),
    ...mapState('settings', {
      sidebarIsVisible: (state: any) => state.sidebarNavigation,
    }),
    ...mapState('spider-list-selection', {
      selected: (state: any) => state.items,
    }),
    ...mapGetters('spiders', ['lastClickedRow']),
    ...mapGetters('auth', ['isAdmin']),
    width(): string {
      return this.sidebarIsVisible ? '75%' : '100%'
    },
  },
  mounted() {
    this.fetch()
  },
  methods: {
    fetch() {
      this.$store.dispatch('spiders/FETCH').catch(err => {
        if (err.response?.status == NOT_FOUND && this.page > 1) {
          setTimeout(() => {
            this.$store.commit('spiders/SET_PAGE', this.page - 1)
            this.fetch()
          }, REPEAT_DELAY)
        } else {
          this.$toastError.fire({ title: 'Ошибка загрузки списка парсеров' })
        }
      })
    },
    onPageChange(page) {
      this.clearLastClickedRow()
      this.$store.commit('spiders/SET_PAGE', page)
      this.fetch()
    },
    onPageSizeChange(pageSize) {
      this.clearLastClickedRow()
      this.$store.commit('spiders/SET_PAGE', 1)
      this.$store.commit('spiders/SET_PAGE_SIZE', pageSize)
      this.fetch()
      this.clearSelection()
    },
    onSortChange(column: string) {
      this.clearLastClickedRow()
      this.$store.commit('spiders/SET_ORDERING', column)
      this.fetch()
      this.clearSelection()
    },
    onRowClick(item) {
      this.setLastClickedRow(item.id)
      this.$router.push({ name: 'SpiderDetail', params: { id: item.id } })
    },
    onFilterChange(filter: any) {
      this.clearLastClickedRow()
      this.$store.commit('spiders/SET_PAGE', 1)
      this.$store.commit('spiders/SET_FILTER', filter)
      this.fetch()
      this.clearSelection()
    },
    showBulkUpdateDialog() {
      if (this.selected.length == 0) {
        this.$toastWarning.fire({ title: 'Перед использованием необходимо отметить парсеры' })
        return
      }

      this.bulkUpdateDialog = true
    },
    showBulkDeleteDialog() {
      if (this.selected.length == 0) {
        this.$toastWarning.fire({ title: 'Перед использованием необходимо отметить парсеры' })
        return
      }

      this.bulkDeleteDialog = true
    },
    showCopySettingsDialog() {
      if (this.selected.length == 0) {
        this.$toastWarning.fire({ title: 'Перед использованием необходимо отметить парсеры' })
        return
      }

      this.bulkCopySettingsDialog = true
    },
    onContextMenu(mouseEvent: MouseEvent, dataEvent: any) {
      mouseEvent.preventDefault()

      this.ctxMenuPositionX = mouseEvent.x
      this.ctxMenuPositionY = mouseEvent.y
      this.ctxMenuVisible = true
      this.ctxMenuItem = dataEvent.item
    },
    showStatusHistoryDialog() {
      if (this.ctxMenuItem == null) {
        return
      }

      getSpiderStatusHistory(this.ctxMenuItem.id).then(({ data }) => {
        this.statusHistoryItems = data
        this.statusHistoryDialog = true
      })
    },
    showPublicationTransferDialog() {
      if (this.selected.length != 1) {
        this.$toastWarning.fire('Для переноса публикаций необходимо выбрать один источник')
        return
      }

      const src = this.selected[0] && (this.selected[0] as any).source
      const dst = this.ctxMenuItem.source
      this.publicationTransferContext = {
        src,
        dst,
      }
      this.publicationTransferDialog = true
    },

    onBulkUpdate(update: any) {
      const ids = this.selected.map(x => x['id'])
      this.$store.dispatch('spiders/BULK_UPDATE', { ids, ...update }).then(
        () => {
          this.$toastSuccess.fire()
          this.fetch()
          this.clearSelection()
        },
        () => {
          this.$toastError.fire()
        },
      )
    },
    onBulkDelete() {
      const ids = this.selected.map(x => x['id'])
      this.$store.dispatch('spiders/BULK_DELETE', { ids }).then(
        () => {
          this.$toastSuccess.fire()
          this.fetch()
          this.clearSelection()
        },
        () => {
          this.$toastError.fire()
        },
      )
    },
    bulkAnalyze() {
      if (this.selected.length == 0) {
        this.$toastWarning.fire({ title: 'Перед использованием необходимо отметить парсеры' })
        return
      }

      const ids = this.selected.map(x => x['id'])
      this.$store.dispatch('spiders/BULK_ANALYZE', { ids }).then(
        () => {
          this.$toastSuccess.fire()
          this.fetch()
          this.clearSelection()
        },
        () => {
          this.$toastError.fire()
        },
      )
    },
    onRowSelect(items: Array<any>) {
      this.$store.commit('spider-list-selection/SET_STATE', items)
    },
    clearSelection() {
      this.$store.commit('spider-list-selection/CLEAR_STATE')
    },
    ...mapMutations({
      setLastClickedRow: 'spiders/SET_LAST_CLICKED_ROW',
      clearLastClickedRow: 'spiders/CLEAR_LAST_CLICKED_ROW',
    }),
  },
})
